import IconButton from '@/components/common/IconButton';
import { useMetadata } from '@/hooks/useMetadata';
import { EventState } from '@/types/eventhandler';
import CancelIcon from '@mui/icons-material/Cancel';
import SaveIcon from '@mui/icons-material/Save';
import { FormControl, InputLabel, MenuItem, Select, Stack, TextField } from '@mui/material';
import { FC, useState } from 'react';
import { SyncEventItem } from './SyncEventsManager';

type SyncEventListItemEditProps = {
  syncEvent?: SyncEventItem;
  onClose: (isEmpty?: boolean) => void;
  onSave: (newEventState: SyncEventItem) => void;
};

const SyncEventListItemEdit: FC<SyncEventListItemEditProps> = (props) => {
  const { metadata } = useMetadata();

  const [eventName, setEventName] = useState(props.syncEvent?.name || '');
  const [eventState, setEventState] = useState<EventState>(props.syncEvent?.state || 'cleared');
  const valid: boolean = !!eventName && !!eventState;

  const handleClose = (isEmpty?: boolean) => {
    setEventName('');
    props.onClose(isEmpty);
  };

  return (
    <Stack
      direction='row'
      gap={1}
      pt={1}
      width='100%'
      alignItems='flex-start'
      alignContent='flex-start'
      bgcolor='action.focus'
      borderRadius={2}
      p={1}
    >
      <Stack gap={1} flexGrow={2} width='100%'>
        <TextField
          label='Sync Event Name'
          value={eventName}
          onChange={(event) => setEventName(event.currentTarget.value.trim())}
          fullWidth
          size='small'
          autoFocus
          required
          InputProps={{ autoComplete: 'off' }}
        />
      </Stack>
      <FormControl fullWidth size='small' sx={{ flexGrow: 1 }} required>
        <InputLabel id='state-select-label' required>
          Initial State
        </InputLabel>
        <Select
          labelId='state-select-label'
          id='state-select'
          value={eventState}
          label='Initial State'
          onChange={(event) => setEventState(event.target.value as EventState)}
          required
        >
          {metadata.synceventstates
            .sort((a, b) => a.state.localeCompare(b.state))
            .map((state, index) => (
              <MenuItem key={`valuetype.${state.state}.${index}`} value={state.state}>
                {state.label}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
      <IconButton
        tooltip={valid ? 'Save' : undefined}
        disabled={!valid}
        onClick={() => {
          if (!valid) return;
          const newEventState: SyncEventItem = {
            name: eventName,
            state: eventState
          };
          props.onSave(newEventState);
          handleClose();
        }}
      >
        <SaveIcon />
      </IconButton>
      <IconButton tooltip='Cancel' onClick={() => handleClose(!props.syncEvent?.name)}>
        <CancelIcon />
      </IconButton>
    </Stack>
  );
};

export default SyncEventListItemEdit;
